import { render, staticRenderFns } from "./SyncSidePanel.vue?vue&type=template&id=5ae42978&scoped=true&"
import script from "./SyncSidePanel.vue?vue&type=script&lang=ts&"
export * from "./SyncSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae42978",
  null
  
)

export default component.exports